import styled from 'styled-components'
  const FilterBox = styled.div`
  height: 40px !important;
  margin-left: 190px;
  text-align: ${props =>
    props.center ? 'center' : props.align ? props.align : 'left'};
  @media (min-width: 40em) {
  }
  /* Moto G4 & Microsoft Lumia 950 & Microsoft Lumia 550 & Galaxy S3 & Galaxy Note 2 & Galaxy Note 3 */
  @media only screen and (device-width: 360px) and (device-height: 640px) {
    margin-left: 240px;
  }
  @media only screen and (device-width: 768px) and (device-height: 1024px) {
    margin-left: 260px;
  }
  @media only screen and (device-width: 1024px) and (device-height: 768px) {
    margin-left: 270px;
  }
  @media only screen and (device-width: 1920px) and (device-height: 1080px) {
    margin-left: 260px;
  }
`;

export default FilterBox